import { css } from 'styled-system/css';

export const homeStyle = {
	root: css({
		_mars: {
			'--body-bg': '{colors.home.bg}',
			height: '100%',
			bgColor: 'home.bg',
			_mdBelow: {
				pb: 'var(--appbar-height)',
			}
		}
	}),
	homeWrapper: css({
		base: {
			display: 'contents',
		},
		_mars: {
			display: 'flex',
			flexDir: 'column',
			bgColor: 'home.bg',
			_mdBelow: {
				overflow: 'auto',
			}
		}
	}),
	notifyIcon: css({
		_mars: {
			color: 'brand.500_light',
		}
	}),
	marquee: css({
		_mars: {
			color: 'black.2',
		}
	}),
	categoryTab: css({}),
	categoryTabItem: css({
		base: {
			h: '40px',
			flex: 1,
			justifyContent: 'center',
		},
		_mars: {
			borderColor: 'black.5',
			'&[data-selected="true"]': {
				color: 'brand.500_light',
			},
		}
	}),
	username: css({
		_mars: {
			color: 'brand.500_light',
		}
	}),
	balance: css({
		_mars: {
			color: 'black.2',
		},
	}),
	navItem: css({
		_mars: {
			color: 'black.2',
			'&[data-selected="true"]': {
				color: 'brand.500_light',
			}
		},
	}),
	product: css({
		_mars: {
			color: 'black.0',
			mt: '6px',
		}
	}),
	productNav: css({
		_mars: {
			pt: '0',
		}
	}),
	productNavItem: css({
		_mars: {
			color: 'black.2',
			borderColor: 'home.productNavBorder',
			boxShadow: '2px 2px 3px {colors.home.productNavShadow}',
			bgGradient: 'to-b',
			gradientFrom: 'home.productNavGradientFrom',
			gradientTo: 'home.productNavGradientTo',
			_active: {
				color: 'whiteOpacity.100',
				gradientFrom: 'primary.100',
				gradientTo: 'primary.500',

			},
		},
	}),
	gameList: css({
		_mars: {
			pt: 0,
		}
	}),
	gameTag: css({
		_mars: {
			color: '#fff',
			backgroundColor: 'home.gameTagBgDisabled',
		},
	}),
	gameItem: css({
		_mars: {
			borderStyle: 'solid',
			borderWidth: '2px',
			borderColor: 'home.gameItemBorder',
			transition: 'border-color 200ms ease-in',
			_hover: {
				borderColor: 'primary.500',
			},
			_disabled: {
				cursor: 'default',
				borderColor: 'home.gameItemBorderDisabled',
				_hover: {
					borderColor: 'home.gameItemBorderDisabled',
				},
				'& .home-product__game-border': {
					gradientTo: 'home.gameGradientBgToDisabled',
				},
			},
		},
	}),
	gameContent: css({
		_mars: {
			bgColor: 'white.1',
		}
	}),
	gameGradientBg: css({
		_mars: {
			bgGradient: 'to-r',
			gradientFrom: 'home.gameGradientBgFrom',
			gradientTo: 'home.gameGradientBgTo',
		},
	}),
}